<div class="subheader-nav">
    <div class="subheader-nav__list-container">
        <ul class="subheader-nav__list sel-primary-nav">
            <ng-container *ngFor="let state of states; trackBy: trackByState">
                <ng-container *ngIf="state.label">
                    <li
                        class="subheader-nav__list-item sel-primary-nav-{{ state.label }}"
                        clrVerticalNavLink
                        *permissionCheck="state.name | stateNameToPermission"
                        uiSrefActive="subheader-nav__list-item--active"
                    >
                        <a
                            href=""
                            [uiSref]="state.name"
                            class="subheader-nav__nav-link"
                        >
                            {{ state.label }}
                        </a>
                    </li>
                </ng-container>
            </ng-container>
        </ul>
    </div>
    <!-- Needed while timeframe and metrics selectors are still displayed in the subheader  -->
    <ng-content></ng-content>
</div>
